<template>
    <horizontal-scroll-outer-wrapper>
        <horizontal-scroll-inner-wrapper>
            <slot />
        </horizontal-scroll-inner-wrapper>
    </horizontal-scroll-outer-wrapper>
</template>

<script>
    import HorizontalScrollOuterWrapper from './HorizontalScrollOuterWrapper.vue';
    import HorizontalScrollInnerWrapper from './HorizontalScrollInnerWrapper.vue';

    export default {
        components: {
            HorizontalScrollOuterWrapper,
            HorizontalScrollInnerWrapper,
        },
    };
</script>